import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loading-dialog',
  template: `
  <div style="display:flex;align-items:center;justify-content:center;height:100%;">
    <mat-spinner diameter="150"></mat-spinner>
  </div>`,
})
export class LoadingDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<LoadingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) { }

}
